export const US_PHONE_NUMBER_MAX_LENGTH = 10;
export const US_COUNTRY_CODE = 'US';
